import { Component, OnInit, Inject } from '@angular/core';
import { ErrorStateMatcher, DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ConfirmComponent } from '../../../shared/dialogs/confirm/confirm.component';
import { StaffService } from '../../../services/staff.service';
import { Staff } from '../../../models/staff';
import { AuthService } from '../../../services/auth.service';
import { SnackBarIconService } from '../../../shared/snack-bar-icon/snack-bar-icon.service';

import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-staff-dialog',
  templateUrl: './staff-dialog.component.html',
  styleUrls: ['./staff-dialog.component.scss'],
  entryComponents: [
    ConfirmComponent
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' }
  ]
})
export class StaffDialogComponent implements OnInit {

  public Editor = ClassicEditor;
  public local_title: string;
  public matcher = new FormErrorStateMatcher(); // filter table
  public entityForm: FormGroup;   // store User Form
  public isEdit: boolean; // is insert or update
  public spinner: boolean = false;


  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private _staffService: StaffService,
    private _authService: AuthService,
    private snackBar: SnackBarIconService,
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DIALOG_DATA) public data: Staff
  ) { }


  ngOnInit() {

    this._adapter.setLocale('pt');

    // check is is insert or update
    if (this.data.id != "0") {
      this.isEdit = true;
      this.local_title = "Staff: " + this.data.name
    } else {
      this.isEdit = false
      this.local_title = "Novo membro de equipe"
    }
    
    this.entityForm = this.createForm()
    this.setFormValues(this.data, this.entityForm)    
  }

  insert() {
    if (this.entityForm.valid) {
      this.spinner = true;
      let entity: Staff = this.createEntity(this.entityForm.value);

      this._staffService.insert(entity)
        .then((result) => {
          this.data.id = result.id
          this.isEdit = true;
          this.entityForm.controls.id.setValue(result.id);
          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        })
        .catch((error) => {
          console.log("insert stff error: " + error)
          let msgError: string = this._staffService.makeMsgError(error.details.code)
          this.snackBar.openSnackBar(msgError, '', 'error');
        })
        .finally(() => {
          this.spinner = false
        });
    }

  }

  update() {
    if (this.entityForm.valid) {

      this.spinner = true;
      let entity: Staff = this.createEntity(this.entityForm.value);

      this._staffService.update(entity)
        .then(() => {
          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        })
        .catch((error) => {
          console.log("staff update error: " + JSON.stringify(error))
          let msgError: string = this._staffService.makeMsgError(error.details.code)
          this.snackBar.openSnackBar(msgError, '', 'error');
        })
        .finally(() => {
          this.spinner = false
        });
    }
  }

  createEntity(data: any): Staff {
    let entity = new Staff();
    entity.id = data.id;
    entity.name = data.name;
    entity.title = data.title ? data.title : "" ; 
    entity.email = data.email ? data.email : "";    
    entity.state = data.state ? data.state : "";
    entity.country = data.country ? data.country : "";
    return entity;
  }

  setFormValues(data, form) {
    form.controls.id.setValue(data.id);
    form.controls.name.setValue(data.name);
    form.controls.title.setValue(data.title);
    form.controls.email.setValue(data.email);
    form.controls.state.setValue(data.state);
    form.controls.country.setValue(data.country);
  }

  createForm() {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      name: new FormControl('', [Validators.required]),
      title: new FormControl(''),
      email: new FormControl(''),
      state: new FormControl(''),
      country: new FormControl('')
    });
    return form
  }


}